// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-item {
  cursor: pointer;
  border-bottom: 4px solid #0000;
  padding: 5px;
}

.pagination-item--disabled {
  cursor: default;
  opacity: .5;
}

.pagination-item--active {
  border-bottom-color: var(--blue-679);
  cursor: default;
}

.pagination-item--arrow {
  color: #999;
  font-size: 1.5em;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/Pagination/Pagination.css","webpack://./services/frontend/app/components/Pagination/Pagination.css"],"names":[],"mappings":"AADA;ECEE,eAAe;EACf,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".pagination-item {\n  padding: 5px;\n  cursor: pointer;\n  border-bottom: 4px solid transparent;\n}\n\n.pagination-item--disabled {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.pagination-item--active {\n  border-bottom-color: var(--blue-679);\n  cursor: default;\n}\n\n.pagination-item--arrow {\n  color: #999;\n  font-size: 1.5em;\n}\n",".pagination-item {\n  cursor: pointer;\n  border-bottom: 4px solid #0000;\n  padding: 5px;\n}\n\n.pagination-item--disabled {\n  cursor: default;\n  opacity: .5;\n}\n\n.pagination-item--active {\n  border-bottom-color: var(--blue-679);\n  cursor: default;\n}\n\n.pagination-item--arrow {\n  color: #999;\n  font-size: 1.5em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
